<template>
  <div class="ocr-tool">
    <div class="editor-pane" v-if="!result && !loading">
      <div class="pane-header"><span class="pane-dot input-dot" /><span class="pane-label">{{ $t('tool.ImageOcr.title') }}</span><span class="pane-hint">PNG / JPEG · Max 50MB</span></div>
      <el-upload ref="upload" drag action="#" :auto-upload="false" :on-change="handleFile" :limit="1" accept="image/png,image/jpeg,image/webp" :file-list="fileList">
        <i class="el-icon-picture-outline" style="font-size:42px;color:#c0c4cc;" />
        <div class="el-upload__text">{{ $t("tool.ImageOcr.dropText") }}<em>{{ $t("tool.ImageOcr.clickUpload") }}</em></div>
      </el-upload>
      <div style="text-align:center;margin-top:14px;" v-if="file">
        <el-button type="primary" size="small" @click="recognize">{{ $t('tool.ImageOcr.btnStart') }}</el-button>
      </div>
    </div>

    <div class="editor-pane" v-if="loading">
      <div class="pane-header"><span class="pane-dot" style="background:#e6a23c;box-shadow:0 0 6px rgba(230,162,60,.4);" /><span class="pane-label">{{ $t('tool.ImageOcr.title') }}</span></div>
      <div style="text-align:center;padding:30px 0;">
        <i class="el-icon-loading" style="font-size:36px;color:#4e7cff;" />
        <p style="margin-top:12px;color:#8892a6;font-size:13px;">{{ $t('tool.ImageOcr.processing') }}</p>
      </div>
    </div>

    <div class="editor-pane" v-if="result">
      <div class="pane-header"><span class="pane-dot output-dot" /><span class="pane-label">{{ $t('tool.ImageOcr.resultLabel') }}</span></div>
      <div class="ocr-out"><code>{{ result }}</code></div>
      <div style="margin-top:12px;display:flex;gap:8px;">
        <el-button size="small" type="primary" @click="copy(result)">{{ $t("common.action.copy") }}</el-button>
        <el-button size="small" @click="downloadTxt">{{ $t('common.action.download') }} TXT</el-button>
        <el-button size="small" @click="reset">{{ $t('tool.ImageOcr.reupload') }}</el-button>
      </div>
    </div>

    <div class="editor-pane" v-if="error">
      <div class="pane-header"><span class="pane-dot" style="background:#f56c6c;" /><span class="pane-label">{{ $t('tool.ImageOcr.title') }}</span></div>
      <div class="ts-err">{{ error }}</div>
      <el-button size="small" @click="reset" style="margin-top:10px;">{{ $t('common.action.reset') }}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name:'ImageOcrTool',props:{config:{type:Object,default:()=>({})}},
  data:()=>({file:null,fileList:[],loading:false,result:'',error:''}),
  methods:{
    handleFile(f){if(f.size>50*1024*1024){this.$message.error(this.$t('tool.ImageOcr.maxSize'));return}this.file=f.raw;this.fileList=[f];this.result='';this.error=''},
    async recognize(){
      if(!this.file)return;this.loading=true;this.error=''
      try{
        // 使用 Tesseract.js CDN
        const Tesseract=window.Tesseract||(await new Promise((resolve,reject)=>{
          const s=document.createElement('script')
          s.src='https://cdn.jsdelivr.net/npm/tesseract.js@5/dist/tesseract.min.js'
          s.onload=()=>resolve(window.Tesseract)
          s.onerror=reject
          document.head.appendChild(s)
        }))
        const worker=await Tesseract.createWorker('chi_sim+eng')
        const {data:{text}}=await worker.recognize(this.file)
        await worker.terminate()
        this.result=this.cleanText(text)||this.$t('tool.ImageOcr.noText')
      }catch(e){this.error=this.$t('common.status.failed')+': '+(e.message||'')}
      this.loading=false
    },
    cleanText(t){
      // 1. 按行处理
      let lines=t.split('\n').map(l=>l.trim())
      // 2. 去掉连续空行
      lines=lines.filter((l,i)=>l||(i>0&&lines[i-1]))
      // 3. 合并被空格拆散的英文单词: "H e l l o" → "Hello"
      //    保留中文间的正常空格，只修复单字符间的空格
      let result=lines.join('\n')
      // 修复 "w o r d" 式拆散
      result=result.replace(/\b(\w) (\w) (\w)\b/g,'$1$2$3')
      result=result.replace(/\b(\w) (\w)\b/g,'$1$2')
      // 4. 去掉 CJK 字符之间的任意空格（循环直到无变化）
      let prev=''
      while(prev!==result){
        prev=result
        result=result.replace(/([一-鿿㐀-䶿豈-﫿])\s+([一-鿿㐀-䶿豈-﫿])/g,'$1$2')
      }
      // 5. 合并多个空格
      result=result.replace(/[ \t]+/g,' ')
      result=result.split('\n').map(l=>l.trim()).join('\n')
      return result.trim()
    },
    reset(){this.file=null;this.fileList=[];this.result='';this.error='';this.loading=false},
    copy(t){navigator.clipboard.writeText(t);this.$message.success(this.$t("common.status.copied"))},
    downloadTxt(){var blob=new Blob([this.result],{type:'text/plain'});var url=URL.createObjectURL(blob);if(/iPhone|iPad|iPod/i.test(navigator.userAgent)){var file=new File([blob],'ocr-result.txt',{type:'text/plain'});if(navigator.share){navigator.share({files:[file]}).catch(function(){window.open(url,'_blank')})}else{window.open(url,'_blank')}}else{var a=document.createElement('a');a.href=url;a.download='ocr-result.txt';document.body.appendChild(a);a.click();document.body.removeChild(a);setTimeout(function(){URL.revokeObjectURL(url)},3000)}},
    doAction(a){if(a==='clear')this.reset()}
  }
}
</script>

<style scoped>
.ocr-tool { display:flex;flex-direction:column;gap:16px; }
.editor-pane { background:#fafbfc;border-radius:12px;border:1px solid #ebeef5;padding:16px 20px; min-width:0; overflow:hidden; }
.pane-header { display:flex;align-items:center;gap:8px;margin-bottom:12px; flex-wrap:wrap; }
.pane-dot { width:8px;height:8px;border-radius:50%;flex-shrink:0; }
.input-dot { background:#4e7cff;box-shadow:0 0 6px rgba(78,124,255,.4); }
.output-dot { background:#43e97b;box-shadow:0 0 6px rgba(67,233,123,.4); }
.pane-label { font-size:13px;font-weight:700;color:#1a1f36; }
.pane-hint { font-size:11px;color:#b0b8c4;margin-left:auto; white-space:nowrap; }
.editor-pane ::v-deep .el-upload { width:100%; }
::v-deep .el-upload-dragger { max-width:100%; width:100%; box-sizing:border-box;  display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:170px; }
.ocr-out { background:#fff;border:1px solid #e4e7ed;border-radius:8px;padding:16px;min-height:80px;max-height:400px;overflow-y:auto; }
.ocr-out code { font-size:14px;color:#303133;white-space:pre-wrap;word-break:break-all;line-height:1.7; }
.ts-err { font-size:13px;color:#f56c6c; }



@media (max-width: 640px) {
  .editor-pane { padding: 12px 14px; }
  .pane-hint { display: none; }
  .editor-pane ::v-deep .el-upload-dragger { min-height: 140px; padding: 20px 12px; }
  .editor-pane ::v-deep .el-upload__text { font-size: 12px; }
}

</style>
